import Vue from 'vue';

import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    allPromotionTrackingReportFileDetail: [],
    allActivePromotionTrackingReportFileDetail: []
  },
  getters: {
    allPromotionTrackingReportFileDetail: (state) => state.allPromotionTrackingReportFileDetail,
    allActivePromotionTrackingReportFileDetail: (state) => state.allActivePromotionTrackingReportFileDetail
  },
  actions: {
    loadAllPromotionTrackingReportFileDetail(context) {
      return new Promise((resolve, reject) => {
        alice
          .getAllPromotionTrackingReportFileDetail()
          .then((response) => {
            const { data } = response.data;
            context.commit('setAllPromotionTrackingReportFileDetail', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadAllActivePromotionTrackingReportFileDetail(context) {
      return new Promise((resolve, reject) => {
        alice
          .getAllActivePromotionTrackingReportFileDetail()
          .then((response) => {
            const { data } = response.data;
            context.commit('setAllActivePromotionTrackingReportFileDetail', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  },
  mutations: {
    setAllPromotionTrackingReportFileDetail(state, data) {
      Vue.set(state, 'allPromotionTrackingReportFileDetail', data);
    },
    setAllActivePromotionTrackingReportFileDetail(state, data) {
      Vue.set(state, 'allActivePromotionTrackingReportFileDetail', data);
    }
  },
};
